import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { CloseHistoryStats, OpenHistoryStats } from './history.actions';
import { HistoryState } from './history.state';
import { Observable } from 'rxjs';
import { HistoryItem } from './models/history-item.model';

@Injectable({
  providedIn: 'root',
})
export class HistoryFacade {
  private readonly store = inject(Store);

  @Select(HistoryState.isStatsModalOpen) isStatsModalOpen$!: Observable<boolean>;
  @Select(HistoryState.historyItem) historyItem$!: Observable<HistoryItem | undefined>;
  @Select(HistoryState.isLoading) isLoading$!: Observable<boolean>;

  openStatsModal(recordId: string, type: string, parentId: string | null = null) {
    this.store.dispatch(new OpenHistoryStats(recordId, type, parentId));
  }

  closeStatsModal() {
    this.store.dispatch(new CloseHistoryStats());
  }
}
